// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"7ae87f24","245":"a58227bc"}[chunkId] + ".chunk.js";
};